// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parallax-wrapper[data-v-2ffa341b]{transition:transform 4s;transition-timing-function:cubic-bezier(0, 0.83, 0.56, 1.06)}`, "",{"version":3,"sources":["webpack://./client/components/ParallaxWrapper.vue"],"names":[],"mappings":"AAGA,mCACE,uBAAA,CACA,4DAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
